import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router";

import { pathRoutes } from "@dfp/bw-react-routing";
import { SplashScreen } from "@dfp/react-api-core";

export const DashboardLazy = lazy(
  () => import("./subAppDashboard/SubAppDashboard"),
);

export const JoinLazy = lazy(() => import("./subAppJoin/JoinApp"));
export const OpsLazy = lazy(() => import("./subAppOps/OpsApp"));

export function AppRoutes() {
  return (
    <Suspense fallback={<SplashScreen />}>
      <Routes>
        <Route path="*" element={<DashboardLazy />} />
        <Route path={pathRoutes.joinAppRoot} element={<JoinLazy />} />
        <Route path={pathRoutes.opsAppRoot} element={<OpsLazy />} />
      </Routes>
    </Suspense>
  );
}
